import React, { Fragment } from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import PropTypes from 'prop-types';

// REDUX ACTIONS
import { saveFormDataAXN } from '../../../../actions/formData/formDataActions';
import { getUserPIIDataV2AXN } from '../../../../actions/transactionHistory/transactionHistoryActions';

// SEARCH RESULTS
// import PhilippinesSuspiciousActivity from './results/PhilippinesSuspiciousActivity';
import DigitalIDSafeguard from './results/DigitalIDSafeguard';
// import WatchlistAML from './results/WatchlistAML';

// VALIDATIONS
import isEmptyVAL from '../../../../validations/checks/isEmptyVAL';

// UTILITIES
import { transUTL } from '../../../../utils/transUTL';
import whitelistedInputDataPH from '../../../formOverview/countryForms/philippines/helpers/whitelistedInputDataPH';
import genderStringUTL from '../../../../utils/genderStringUTL';
import { dataSourcesIsCheckedUTL } from '../../../../utils/outputMasterUTL';

const DigitalIdSafeguardResults = ({
  authRXS,
  countryRXS,
  dataSourcesRXS,
  formDataRXS,
  searchVerificationRXS,
  saveFormDataAXN,
  getUserPIIDataV2AXN,
  watchlistStatus,
  handleClearResults,
  history,
}) => {

  const { digitalIdSafeguardFormData } = formDataRXS;

  const selectedDataSources = dataSourcesIsCheckedUTL(
    dataSourcesRXS.findIDUDataSources
  );

  let { serviceResponses } = searchVerificationRXS;
  if (isEmptyVAL(serviceResponses)) {
    serviceResponses = {};
  }

  const whitelistedData = whitelistedInputDataPH(
    digitalIdSafeguardFormData,
    'Digital Id Safeguard'
  );

  const {
    nationalIdConsentObtained,
    VoterRegistrationConsentObtained,
    ...displayData
  } = whitelistedData;

  displayData.gender = genderStringUTL(displayData);

  const displayDataFiltered = Object.keys(displayData)
    .map((val) => displayData[val])
    .filter((v) => !isEmptyVAL(v));
    
  // GENERATE PDF
  const generatePDF = () =>
    getUserPIIDataV2AXN(authRXS.user, searchVerificationRXS.reportingReference);

  return (
    <Fragment>
      <header className="header-secondary search-verification__input-data">
        <h4 className="header-title-secondary">
          <strong>{transUTL('translateSearchVerification.inputData')}</strong>{' '}
          {displayDataFiltered.join(' | ')}
        </h4>
      </header>

      {/* {!isEmptyVAL(serviceResponses) && (
        <PhilippinesSuspiciousActivity
          results={serviceResponses}
          type="Philippines Suspicious Activity"
        />
      )} */}
      {/* {!isEmptyVAL(serviceResponses) && (
        <WatchlistAML
          results={serviceResponses}
          type="Watchlist AML"
        />
      )} */}
      {!isEmptyVAL(serviceResponses) && (
        <DigitalIDSafeguard
          results={serviceResponses}
          type="Digital ID Safeguard"
        />
      )}

      {/* BUTTONS */}
      <div className={(!isEmptyVAL(serviceResponses["Watchlist AML"]) && (Object.keys(serviceResponses).length === 2)) 
      ? "search-verification__btn" : "search-verification__btns"}>
        <div className="btn-container btn-under">
          <button
            className="btn-primary"
            onClick={() => history.push('/digital-id-safeguard-form-overview')}
          >
            {transUTL('translateBtn.editSearch')}
          </button>

          <button className="btn-primary" onClick={handleClearResults}>
            {transUTL('translateBtn.newSearch')}
          </button>
        </div>

        <div className="btn-container btn-under">
          <button className="btn-primary" onClick={generatePDF}>
            {transUTL('translateBtn.generatePDF')}
          </button>

          <button className="btn-primary" onClick={() => window.print(history.push('/digital-id-safeguard-search-verification'))}>
            {transUTL('translateBtn.printSearchResults')}
          </button>
        </div>
      </div>
    </Fragment>
  );
};

DigitalIdSafeguardResults.propTypes = {
  authRXS: PropTypes.object.isRequired,
  countryRXS: PropTypes.string.isRequired,
  dataSourcesRXS: PropTypes.object.isRequired,
  formDataRXS: PropTypes.object.isRequired,
  searchVerificationRXS: PropTypes.object.isRequired,
  saveFormDataAXN: PropTypes.func.isRequired,
  getUserPIIDataV2AXN: PropTypes.func.isRequired,
  watchlistStatus: PropTypes.object.isRequired,
  handleClearResults: PropTypes.func.isRequired,
};

const mapStateToProps = (state) => ({
  authRXS: state.authRXS,
  countryRXS: state.countryRXS,
  dataSourcesRXS: state.dataSourcesRXS,
  formDataRXS: state.formDataRXS,
  searchVerificationRXS: state.searchVerificationRXS,
});

export default connect(mapStateToProps, {
  saveFormDataAXN,
  getUserPIIDataV2AXN,
})(withRouter(DigitalIdSafeguardResults));
